import React from 'react'
import { Link } from 'gatsby'

const LinkWrap = ({
  to,
  className,
  partiallyActive = true,
  children,
  state,
}) => {
  let setState = {}
  if (state) setState = state
  let setTo = null
  if (to && to !== '#') {
    setTo = to
  }
  if (setTo) {
    return (
      <Link
        to={setTo}
        className={className}
        activeClassName='active'
        partiallyActive={partiallyActive}
        state={setState}
      >
        {children}
      </Link>
    )
  } else {
    return <a className={className}>{children}</a>
  }
}

export default LinkWrap
